var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import { hasFeature } from '@shared/featureFlags/featureFlags';
import { InsurerFeatureFlag } from '@shared/featureFlags/insurerFeatureFlags';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
const qualification = namespace('qualification');
const settings = namespace('settings');
let WaintingForManagement = class WaintingForManagement extends Vue {
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get image() {
        return require('@declaration/assets/images/appointment/managerCall.svg');
    }
    get waitingForManagementWording2() {
        return hasFeature(InsurerFeatureFlag.DisplayWaitingForManagementWording2, this.typeTrigram);
    }
    get title() {
        return this.waitingForManagementWording2
            ? this.$tc('waiting_for_management.title.wording2')
            : this.$tc('waiting_for_management.title');
    }
    get message() {
        var _a, _b, _c, _d;
        if (this.waitingForManagementWording2) {
            return this.$tc('waiting_for_management.message.wording2', undefined, {
                phoneNumber: (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.advisorPhoneNumbers) === null || _c === void 0 ? void 0 : _c.france) !== null && _d !== void 0 ? _d : '01 XX XX XX XX',
            });
        }
        return this.$tc('waiting_for_management.message');
    }
};
__decorate([
    qualification.State('typeTrigram')
], WaintingForManagement.prototype, "typeTrigram", void 0);
__decorate([
    settings.Getter('setting')
], WaintingForManagement.prototype, "setting", void 0);
WaintingForManagement = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
            goBack: null,
        },
    })
], WaintingForManagement);
export default WaintingForManagement;
